import React, { useState, useEffect, useContext } from 'react';
import './wallet.sass';
import { FormattedNumber } from 'react-intl';
import { Trans, useTranslation } from 'react-i18next';
import { faQuestionCircle, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { DrawerCustom, DropdownCustom, FontIconsCustom, ParagraphCustom } from '../custom/index';
import { LangContext } from '../../hooks/context/lang';
import { DetailBank } from './detailBank';
import { RestApiClientContext } from '../../hooks/context/pageContext';
import { Button, Checkbox, Dropdown, Menu, Modal, Space, Switch, Timeline } from 'antd';
import moment from 'moment';
import { PickerLocale } from 'antd/lib/date-picker/generatePicker';
import { getLocaleDatePicker } from 'src/utils/datePicker';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

// Componente Base de la parte publica de nuestra aplicación
export const Wallet = () => {
    // Libreria i18n para traducir
    const { t } = useTranslation(['urls', 'linksNames', 'translation', 'wallet']);
    const [depositDeleteVisible, setDepositDeleteVisible] = useState('');
    const [depositToAdd, setDepositToAdd] = useState('');
    const restApiClient = useContext(RestApiClientContext);
    const [listExchange, setListExchange] = useState([]);
    const [listDeposists, setListDeposists] = useState<any>();
    const local: PickerLocale = getLocaleDatePicker();
    const [visible, setVisible] = useState(false);
    const [visibleChildren, setVisibleChildren] = useState(false);
    const [visibleChildrenDeposit, setVisibleChildrenDeposit] = useState(false);
    const [dataBank, setDataBank] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingMovements, setIsLoadingMovements] = useState(false);
    const [isLoadingRecharger, setIsLoadingRecharger] = useState(false);
    const [currencies, setCurrencies] = useState([]);
    // Contexto con los datos del usuario si esta logado
    const language = useContext(LangContext);
    const userLang = language.GetLangContext();

    async function getInitialData() {
        setIsLoading(true);
        await restApiClient.getAvailableBalances(userLang).then((data) => {
            if (data) {
                setListExchange(data);
            }
        });
        await restApiClient.getAllCurrenciesPossible().then((data) => {
            setCurrencies(data);
        });
        setIsLoading(false);
    }
    useEffect(() => {
        getInitialData();
    }, []);

    // Muestra el panel Drawer con la lista de divisas
    const showDrawer = () => {
        setVisible(true);
    };

    const showChildrenDrawer = (idCurrency) => {
        setIsLoadingRecharger(true);
        restApiClient
            .getBankDetailsByCurrency(idCurrency)
            .then((data) => {
                if (data) {
                    setDataBank(data);
                }

                setVisibleChildren(true);
            })
            .finally(() => setIsLoadingRecharger(false));
    };

    const onClose = () => {
        setVisible(false);
    };

    const onCloseChildrenDrawer = () => {
        setVisibleChildren(false);
    };
    const showMovements = (id) => {
        setIsLoadingMovements(true);
        restApiClient
            .getDeposits(id)
            .then((data) => {
                if (data) {
                    setListDeposists(data);
                    setVisibleChildrenDeposit(true);
                }
            })
            .finally(() => setIsLoadingMovements(false));
    };
    const deleteExchange = (id) => {
        restApiClient
            .RemoveDeposits(id, checked)
            .then(() => {
                setListExchange((prev) =>
                    prev.map((e) => (e.id === id ? { ...e, isAvailable: false } : e)),
                );
            })
            .finally(() => {
                setChecked(false);
                setDepositDeleteVisible('');
            });
    };
    const AddDeposit = (idCurrency) => {
        restApiClient
            .AddDeposits(idCurrency, checked)
            .then(() => {
                setListExchange((prev) =>
                    prev.map((e) => (e.id === idCurrency ? { ...e, isAvailable: true } : e)),
                );
            })
            .finally(() => {
                setChecked(false);
                setDepositToAdd('');
            });
    };
    const [checked, setChecked] = useState(false);
    // Elemento dentro del Dropdown
    const exchange = (
        <>
            {!isLoading && (
                <div className="dropdown-exchange" onClick={showDrawer}>
                    {t('translation:view-more-exchanges')}
                </div>
            )}
            <Modal
                visible={depositDeleteVisible !== ''}
                title={t('wallet:delete-deposit-title')}
                onCancel={() => setDepositDeleteVisible('')}
                okText={t('wallet:ok')}
                cancelText={t('wallet:cancel')}
                onOk={() => {
                    deleteExchange(depositDeleteVisible);
                }}
            >
                <p>
                    <Trans
                        i18nKey="wallet:delete-deposit-text1"
                        values={{
                            currency:
                                listExchange.find((e) => e.id === depositDeleteVisible)
                                    ?.nameCurrency || 'N/A',
                        }}
                        components={{ strong: <strong /> }}
                    />
                </p>
                <p>{t('wallet:delete-deposit-text2')}</p>
                <p style={{ marginBottom: 0 }}>
                    <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)}>
                        {t('wallet:delete-deposit-text3')}
                    </Checkbox>
                </p>
                <p style={{ color: 'gray' }}>{t('wallet:delete-deposit-text3-message')}</p>
            </Modal>
            <Modal
                visible={depositToAdd !== ''}
                title={t('wallet:add-deposit-title')}
                onCancel={() => setDepositToAdd('')}
                okText={t('wallet:ok')}
                cancelText={t('wallet:cancel')}
                onOk={() => AddDeposit(depositToAdd)}
            >
                <p>
                    <Trans
                        i18nKey="wallet:add-deposit-text1"
                        values={{
                            currency: listExchange.find((e) => e.id === depositToAdd)?.nameCurrency,
                        }}
                        components={{ strong: <strong /> }}
                    />
                </p>

                <p style={{ marginBottom: 0 }}>
                    <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)}>
                        {t('wallet:add-deposit-text2')}
                    </Checkbox>
                </p>
                <p style={{ color: 'gray' }}>{t('wallet:add-deposit-text2-message')}</p>
            </Modal>
            <DrawerCustom
                title={t('wallet:available-amounts')}
                class="list-wallet"
                visible={visible}
                closable={false}
                setVisible={setVisible}
                info={''}
                width={320}
                onClose={onClose}
                content={
                    <>
                        {/* <div style={{ paddingInline: '24px', display: 'flex', justifyContent: 'center' }}>
                            {currencies.filter(c => !listExchange.some(e => e.idCurrency === c.id)).length > 0 && <Dropdown
                                placement="bottom"
                                trigger={['click']}
                                getPopupContainer={trigger => trigger.parentNode as HTMLElement} overlay={<Menu>
                                    {currencies.filter(c => !listExchange.some(e => e.idCurrency === c.id)).map(currency =>
                                        <div style={{ padding: 5, cursor: 'pointer', textAlign: 'center' }} key={currency.id} onClick={() => { AddDeposit(currency.id) }}>
                                            {currency.id} - {currency.symbol}
                                        </div>
                                    )}

                                </Menu>} >
                                <Button type="link">
                                    <Space>
                                        <PlusOutlined /> Añadir moneda
                                    </Space>
                                </Button>
                            </Dropdown>}
                        </div> */}
                        {listExchange.map((e, i) => {
                            const backgroundColor = i % 2 === 0 ? 'white' : 'rgb(246 246 246)';
                            return (
                                <div key={i} style={{ backgroundColor }} className="exchange-pair">
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            justifyContent: 'space-between',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        <ParagraphCustom
                                            class="exchange-name"
                                            text={e.nameCurrency}
                                        />
                                        {/* {e.canBeDeleted && <Button
                                            type="ghost"
                                            onClick={() => { deleteExchange(e.id) }}>
                                            <DeleteOutlined />
                                        </Button>} */}
                                        <Switch
                                            size="small"
                                            loading={depositDeleteVisible !== ''}
                                            checked={e.isAvailable}
                                            onChange={(checked) =>
                                                !checked
                                                    ? setDepositDeleteVisible(e.id)
                                                    : setDepositToAdd(e.id)
                                            }
                                        />
                                    </div>
                                    <ParagraphCustom
                                        class={
                                            'exchange-amount' +
                                            (e.minimumAllowed ? ' red-color' : '')
                                        }
                                        text={
                                            <FormattedNumber
                                                value={e.amount}
                                                style="currency"
                                                currency={e.idCurrency}
                                            />
                                        }
                                    />
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '10px',
                                            justifyContent: 'space-between',
                                            marginTop: '5px',
                                        }}
                                    >
                                        <Button
                                            style={{ width: '100%' }}
                                            disabled={isLoadingMovements || isLoadingRecharger}
                                            onClick={() => {
                                                showChildrenDrawer(e.idCurrency);
                                            }}
                                            type="primary"
                                        >
                                            {isLoading ? t('wallet:loading') : t('wallet:reload')}
                                        </Button>
                                        <Button
                                            style={{ width: '100%' }}
                                            disabled={isLoadingMovements || isLoadingRecharger}
                                            onClick={() => showMovements(e.id)}
                                            type="primary"
                                        >
                                            {isLoading
                                                ? t('wallet:loading')
                                                : t('wallet:movements')}
                                        </Button>
                                    </div>
                                </div>
                            );
                        })}
                        <DrawerCustom
                            visible={visibleChildren}
                            title={t('wallet:reload-amount')}
                            placement="right"
                            closable={false}
                            width={350}
                            onClose={onCloseChildrenDrawer}
                            content={<DetailBank data={dataBank} />}
                        />
                        <DrawerCustom
                            visible={visibleChildrenDeposit}
                            title={t('wallet:movements')}
                            placement="right"
                            closable={false}
                            width={350}
                            onClose={() => setVisibleChildrenDeposit(false)}
                            content={
                                <div className="content-movements">
                                    <p className="app-title">{t('wallet:initial-balance')}</p>
                                    <p className="initial-balance">
                                        {listDeposists?.initialBalance.amount +
                                            ' ' +
                                            listDeposists?.initialBalance.idCurrency}
                                        <small>
                                            {moment(
                                                listDeposists?.initialBalance.depositDate,
                                            ).format(local.dateFormat)}
                                        </small>
                                    </p>
                                    <p className="app-title">{t('wallet:movements')}</p>
                                    <Timeline className="movements-timeline">
                                        {listDeposists?.haveMovements ? (
                                            listDeposists?.deposits.map((deposit) => (
                                                <Timeline.Item
                                                    color={deposit.isSum ? 'green' : 'red'}
                                                    key={deposit.id}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '10px',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <p>
                                                            <strong>
                                                                {moment(deposit.depositDate).format(
                                                                    local.dateFormat,
                                                                )}
                                                            </strong>
                                                        </p>
                                                        <p
                                                            style={{
                                                                color: deposit.isSum
                                                                    ? 'green'
                                                                    : 'red',
                                                            }}
                                                        >
                                                            {deposit.amount +
                                                                ' ' +
                                                                deposit.idCurrency}
                                                        </p>
                                                    </div>
                                                </Timeline.Item>
                                            ))
                                        ) : (
                                            <p>{t('wallet:no-deposits')}</p>
                                        )}
                                    </Timeline>
                                    {listDeposists?.haveMovements && (
                                        <div className="previously-movements">
                                            <p className="app-title">
                                                {t('wallet:previous-movements')}
                                            </p>
                                            <span>
                                                {t('wallet:income')}:{' '}
                                                {listDeposists?.previously.income.amount}{' '}
                                                {listDeposists?.initialBalance.idCurrency}
                                                <small>
                                                    {moment(
                                                        listDeposists?.previously.income.from,
                                                    ).format(local.dateFormat)}{' '}
                                                    -{' '}
                                                    {moment(
                                                        listDeposists?.previously.income.to,
                                                    ).format(local.dateFormat)}
                                                </small>
                                            </span>
                                            <span>
                                                {t('wallet:outcome')}:{' '}
                                                {listDeposists?.previously.bills.amount}{' '}
                                                {listDeposists?.initialBalance.idCurrency}
                                                <small>
                                                    {moment(
                                                        listDeposists?.previously.bills.from,
                                                    ).format(local.dateFormat)}{' '}
                                                    -{' '}
                                                    {moment(
                                                        listDeposists?.previously.bills.to,
                                                    ).format(local.dateFormat)}
                                                </small>
                                            </span>
                                        </div>
                                    )}
                                </div>
                            }
                        />
                    </>
                }
            />
        </>
    );

    return (
        <div className="row content-wallet">
            <div className="col-12 col-lg-11">
                {t('translation:available-amount')}
                <FontIconsCustom
                    tooltip={t('wallet:tooltip-info')}
                    classIcon="icons-color-menu icons-color-marging q-icon"
                    icon={faQuestionCircle}
                />
            </div>
            <div className="d-none d-lg-block col-lg-1 p-0"></div>
            <DropdownCustom overlay={exchange} className="row wallet-content">
                <div className="col-12 values-wallet">
                    <div className="content-currency">
                        {!isLoading ? (
                            listExchange.slice(0, 3).map((e, i) => {
                                return (
                                    <span key={e.id}>
                                        <span
                                            className={
                                                e.minimumAllowed
                                                    ? 'text-min-allowed'
                                                    : 'text-no-min-allowed'
                                            }
                                        >
                                            <FormattedNumber
                                                value={e.amount}
                                                style="currency"
                                                currency={e.idCurrency}
                                            />
                                        </span>
                                        {i < 2 ? ' | ' : ' '}
                                    </span>
                                );
                            })
                        ) : (
                            <span style={{ display: 'block' }} className="text-no-min-allowed">
                                {t('wallet:loading')}
                            </span>
                        )}

                        {!isLoading && (
                            <FontIconsCustom
                                classIcon="icons-color-menu margin-icon-wallet chevron-language secondary-links-svg"
                                icon={faChevronDown}
                            />
                        )}
                    </div>
                </div>
            </DropdownCustom>
        </div>
    );
};
